import axios from "axios";

// Resolve API base URL:
// 1) Use REACT_APP_API_BASE_URL if set
// 2) Otherwise:
//    - if running locally, use :5000
//    - else default to production API domain
const envBase = process.env.REACT_APP_API_BASE_URL;

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.startsWith("192.168.") ||
    window.location.hostname.startsWith("10.") ||
    window.location.hostname.startsWith("172.16."));

const API_BASE =
  envBase ||
  (isLocalHost
    ? `${window.location.protocol}//${window.location.hostname}:5000`
    : "https://api.unicodexglobal.com");

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
  timeout: 15000,
});

// Attach manufacturer portal token if present
api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("ucx_mfg_token");
      if (token) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (e) {
      // ignore
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;
